import { useCapabilitiesStore } from '@/stores/capabilities'
import { FEATURES, useFeaturesStore } from '@/stores/features'
import { useRoomStore } from '@/stores/room'

/**
 * returns whether the corresponding button should be visible and enabled
 * - button `visible` if one of the `capabilities` is enabled and the FF is enabled
 * - button `enabled` if the current state matches the `capability` state
 * i.e. (currently muted and can unmute) or (currently unmute and can mute)
 */
export const useSelfRoomLockButtonState = () => {
  const roomLocked = useRoomStore(state => state.roomLocked)
  const isAudioOnly = useRoomStore(state => state.isAudioOnly)

  const selfRoomLockCapabilityOn = useCapabilitiesStore(
    state => state.selfRoomLockCapabilityOn,
  )
  const selfRoomLockCapabilityOff = useCapabilitiesStore(
    state => state.selfRoomLockCapabilityOff,
  )
  const isFeatureDisabled = useFeaturesStore(
    state => state.disabled.ROOM_LOCK === FEATURES.ROOM_LOCK,
  )

  // button visible if one of the capabilities is enabled and FF is enabled
  const isRoomLockButtonVisible =
    !isAudioOnly &&
    !isFeatureDisabled &&
    (selfRoomLockCapabilityOff || selfRoomLockCapabilityOn)

  const canLockRoom = !roomLocked && selfRoomLockCapabilityOn
  const canUnlockRoom = roomLocked && selfRoomLockCapabilityOff

  // check if button can perform the necessary next action
  const isRoomLockButtonEnabled = canLockRoom || canUnlockRoom

  return { isRoomLockButtonEnabled, isRoomLockButtonVisible }
}
